import Notification from "./Notification";
import ListWrapper from "../utils/ListWrapper";
import Person from "./Person";
import NOKUser from "./NOKUser";
import DateTime from "../core/DateTime";
import RequestStatus from "../classes/RequestStatus";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";
import CollectionUtils from "../utils/CollectionUtils";
import Invoice from "./Invoice";
import Hospital from "./Hospital";

export default class SearchRequest extends DBObject {
  private static readonly _ADDRESSLINE1: number = 0;
  private static readonly _ADDRESSLINE2: number = 1;
  private static readonly _CITY: number = 2;
  private static readonly _CREATEDBY: number = 3;
  private static readonly _DATEOFBIRTH: number = 4;
  private static readonly _FAILEDMESSAGE: number = 5;
  private static readonly _FIRSTNAME: number = 6;
  private static readonly _HOSPITAL: number = 7;
  private static readonly _INVOICE: number = 8;
  private static readonly _ISADVANCEDSEARCH: number = 9;
  private static readonly _ISBILLED: number = 10;
  private static readonly _LASTNAME: number = 11;
  private static readonly _MIDDLENAME: number = 12;
  private static readonly _MOBILE: number = 13;
  private static readonly _NOTES: number = 14;
  private static readonly _NOTIFICATION: number = 15;
  private static readonly _REQUESTDATE: number = 16;
  private static readonly _RESPONSE: number = 17;
  private static readonly _SSN: number = 18;
  private static readonly _SEARCHID: number = 19;
  private static readonly _STATE: number = 20;
  private static readonly _STATUS: number = 21;
  private static readonly _TAHOEID: number = 22;
  private static readonly _ZIP: number = 23;
  public id: number = 0;
  public otherMaster: DBObject;
  private _notes: string = "";
  private _requestDate: DateTime = null;
  private _createdBy: NOKUser = null;
  private _status: RequestStatus = RequestStatus.Processing;
  private _firstName: string = "";
  private _middleName: string = "";
  private _lastName: string = "";
  private _mobile: string = "";
  private _dateOfBirth: string = "";
  private _response: Array<Person> = ListWrapper.inverse(
    this,
    "response",
    SearchRequest._RESPONSE
  );
  private _failedMessage: string = "";
  private _sSN: string = "";
  private _isAdvancedSearch: boolean = false;
  private _isBilled: boolean = false;
  private _searchId: string = "";
  private _tahoeId: string = "";
  private _addressLine1: string = "";
  private _addressLine2: string = "";
  private _city: string = "";
  private _state: string = "";
  private _zip: string = "";
  private _invoice: Invoice = null;
  private _notification: Notification = null;
  private _hospital: Hospital = null;
  public constructor(
    d3eParams?: Partial<{
      addressLine1: string;
      addressLine2: string;
      city: string;
      createdBy: NOKUser;
      dateOfBirth: string;
      failedMessage: string;
      firstName: string;
      hospital: Hospital;
      invoice: Invoice;
      isAdvancedSearch: boolean;
      isBilled: boolean;
      lastName: string;
      middleName: string;
      mobile: string;
      notes: string;
      notification: Notification;
      requestDate: DateTime;
      response: Array<Person>;
      sSN: string;
      searchId: string;
      state: string;
      status: RequestStatus;
      tahoeId: string;
      zip: string;
    }>
  ) {
    super();

    this.setAddressLine1(d3eParams?.addressLine1 ?? "");

    this.setAddressLine2(d3eParams?.addressLine2 ?? "");

    this.setCity(d3eParams?.city ?? "");

    this.setCreatedBy(d3eParams?.createdBy ?? null);

    this.setDateOfBirth(d3eParams?.dateOfBirth ?? "");

    this.setFailedMessage(d3eParams?.failedMessage ?? "");

    this.setFirstName(d3eParams?.firstName ?? "");

    this.setHospital(d3eParams?.hospital ?? null);

    this.setInvoice(d3eParams?.invoice ?? null);

    this.setIsAdvancedSearch(d3eParams?.isAdvancedSearch ?? false);

    this.setIsBilled(d3eParams?.isBilled ?? false);

    this.setLastName(d3eParams?.lastName ?? "");

    this.setMiddleName(d3eParams?.middleName ?? "");

    this.setMobile(d3eParams?.mobile ?? "");

    this.setNotes(d3eParams?.notes ?? "");

    this.setNotification(d3eParams?.notification ?? null);

    this.setRequestDate(d3eParams?.requestDate ?? null);

    this.setResponse(
      d3eParams?.response ??
        ListWrapper.inverse(this, "response", SearchRequest._RESPONSE)
    );

    this.setSSN(d3eParams?.sSN ?? "");

    this.setSearchId(d3eParams?.searchId ?? "");

    this.setState(d3eParams?.state ?? "");

    this.setStatus(d3eParams?.status ?? RequestStatus.Processing);

    this.setTahoeId(d3eParams?.tahoeId ?? "");

    this.setZip(d3eParams?.zip ?? "");
  }
  public get d3eType(): string {
    return "SearchRequest";
  }
  public static updateResponseInverse(on: any, obj: any, type: string): void {
    if ("Insert" === type) {
      on.addToResponse(obj as Person);
    }

    if ("Delete" === type) {
      on.removeFromResponse(obj as Person);
    }
  }
  public toString(): string {
    return this.searchId;
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get notes(): string {
    return this._notes;
  }
  public setNotes(val: string): void {
    let isValChanged: boolean = this._notes !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._NOTES, this._notes);

    this._notes = val;

    this.fire("notes", this);
  }
  public get requestDate(): DateTime {
    return this._requestDate;
  }
  public setRequestDate(val: DateTime): void {
    let isValChanged: boolean = this._requestDate !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._REQUESTDATE, this._requestDate);

    this._requestDate = val;

    this.fire("requestDate", this);
  }
  public get createdBy(): NOKUser {
    return this._createdBy;
  }
  public setCreatedBy(val: NOKUser): void {
    let isValChanged: boolean = this._createdBy !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._CREATEDBY, this._createdBy);

    this.updateObservable("createdBy", this._createdBy, val);

    this._createdBy = val;

    this.fire("createdBy", this);
  }
  public get status(): RequestStatus {
    return this._status;
  }
  public setStatus(val: RequestStatus): void {
    let isValChanged: boolean = this._status !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._STATUS, this._status.index);

    this._status = val;

    this.fire("status", this);
  }
  public get firstName(): string {
    return this._firstName;
  }
  public setFirstName(val: string): void {
    let isValChanged: boolean = this._firstName !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._FIRSTNAME, this._firstName);

    this._firstName = val;

    this.fire("firstName", this);
  }
  public get middleName(): string {
    return this._middleName;
  }
  public setMiddleName(val: string): void {
    let isValChanged: boolean = this._middleName !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._MIDDLENAME, this._middleName);

    this._middleName = val;

    this.fire("middleName", this);
  }
  public get lastName(): string {
    return this._lastName;
  }
  public setLastName(val: string): void {
    let isValChanged: boolean = this._lastName !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._LASTNAME, this._lastName);

    this._lastName = val;

    this.fire("lastName", this);
  }
  public get mobile(): string {
    return this._mobile;
  }
  public setMobile(val: string): void {
    let isValChanged: boolean = this._mobile !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._MOBILE, this._mobile);

    this._mobile = val;

    this.fire("mobile", this);
  }
  public get dateOfBirth(): string {
    return this._dateOfBirth;
  }
  public setDateOfBirth(val: string): void {
    let isValChanged: boolean = this._dateOfBirth !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._DATEOFBIRTH, this._dateOfBirth);

    this._dateOfBirth = val;

    this.fire("dateOfBirth", this);
  }
  public get response(): Array<Person> {
    return this._response;
  }
  public setResponse(val: Array<Person>): void {
    let isValChanged: boolean = CollectionUtils.isNotEquals(
      this._response,
      val
    );

    if (!isValChanged) {
      return;
    }

    if (!this.d3eChanges.contains(SearchRequest._RESPONSE)) {
      let _old: Array<Person> = Array.from(this._response);

      this.updateD3EChanges(SearchRequest._RESPONSE, _old);
    }

    this.updateObservableColl("response", this._response, val);

    this._response.clear();

    this._response.addAll(val);

    this.fire("response", this);
  }
  public addToResponse(val: Person, index: number = -1): void {
    let _old: Array<Person> = [];

    let _isNewChange: boolean = !this.d3eChanges.contains(
      SearchRequest._RESPONSE
    );

    if (_isNewChange) {
      _old = Array.from(this._response);
    }

    if (index === -1) {
      if (!this._response.contains(val)) this._response.add(val);
    } else {
      this._response.remove(this._response.elementAt(index));

      this._response.add(val);
    }

    this.fire("response", this, val, true);

    this.updateObservable("response", null, val);

    if (_isNewChange) {
      this.updateD3EChanges(SearchRequest._RESPONSE, _old);
    }
  }
  public removeFromResponse(val: Person): void {
    let _old: Array<Person> = [];

    let _isNewChange: boolean = !this.d3eChanges.contains(
      SearchRequest._RESPONSE
    );

    if (_isNewChange) {
      _old = Array.from(this._response);
    }

    this._response.remove(val);

    this.fire("response", this, val, false);

    if (_isNewChange) {
      this.updateD3EChanges(SearchRequest._RESPONSE, _old);
    }
  }
  public get failedMessage(): string {
    return this._failedMessage;
  }
  public setFailedMessage(val: string): void {
    let isValChanged: boolean = this._failedMessage !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._FAILEDMESSAGE, this._failedMessage);

    this._failedMessage = val;

    this.fire("failedMessage", this);
  }
  public get sSN(): string {
    return this._sSN;
  }
  public setSSN(val: string): void {
    let isValChanged: boolean = this._sSN !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._SSN, this._sSN);

    this._sSN = val;

    this.fire("sSN", this);
  }
  public get isAdvancedSearch(): boolean {
    return this._isAdvancedSearch;
  }
  public setIsAdvancedSearch(val: boolean): void {
    let isValChanged: boolean = this._isAdvancedSearch !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(
      SearchRequest._ISADVANCEDSEARCH,
      this._isAdvancedSearch
    );

    this._isAdvancedSearch = val;

    this.fire("isAdvancedSearch", this);
  }
  public get isBilled(): boolean {
    return this._isBilled;
  }
  public setIsBilled(val: boolean): void {
    let isValChanged: boolean = this._isBilled !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._ISBILLED, this._isBilled);

    this._isBilled = val;

    this.fire("isBilled", this);
  }
  public get searchId(): string {
    return this._searchId;
  }
  public setSearchId(val: string): void {
    let isValChanged: boolean = this._searchId !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._SEARCHID, this._searchId);

    this._searchId = val;

    this.fire("searchId", this);
  }
  public get tahoeId(): string {
    return this._tahoeId;
  }
  public setTahoeId(val: string): void {
    let isValChanged: boolean = this._tahoeId !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._TAHOEID, this._tahoeId);

    this._tahoeId = val;

    this.fire("tahoeId", this);
  }
  public get addressLine1(): string {
    return this._addressLine1;
  }
  public setAddressLine1(val: string): void {
    let isValChanged: boolean = this._addressLine1 !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._ADDRESSLINE1, this._addressLine1);

    this._addressLine1 = val;

    this.fire("addressLine1", this);
  }
  public get addressLine2(): string {
    return this._addressLine2;
  }
  public setAddressLine2(val: string): void {
    let isValChanged: boolean = this._addressLine2 !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._ADDRESSLINE2, this._addressLine2);

    this._addressLine2 = val;

    this.fire("addressLine2", this);
  }
  public get city(): string {
    return this._city;
  }
  public setCity(val: string): void {
    let isValChanged: boolean = this._city !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._CITY, this._city);

    this._city = val;

    this.fire("city", this);
  }
  public get state(): string {
    return this._state;
  }
  public setState(val: string): void {
    let isValChanged: boolean = this._state !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._STATE, this._state);

    this._state = val;

    this.fire("state", this);
  }
  public get zip(): string {
    return this._zip;
  }
  public setZip(val: string): void {
    let isValChanged: boolean = this._zip !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._ZIP, this._zip);

    this._zip = val;

    this.fire("zip", this);
  }
  public get invoice(): Invoice {
    return this._invoice;
  }
  public setInvoice(val: Invoice): void {
    let isValChanged: boolean = this._invoice !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._INVOICE, this._invoice);

    this.updateObservable("invoice", this._invoice, val);

    this._invoice = val;

    this.fire("invoice", this);
  }
  public get notification(): Notification {
    return this._notification;
  }
  public setNotification(val: Notification): void {
    let isValChanged: boolean = this._notification !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._NOTIFICATION, this._notification);

    this.updateObservable("notification", this._notification, val);

    this._notification = val;

    this.fire("notification", this);
  }
  public get hospital(): Hospital {
    return this._hospital;
  }
  public setHospital(val: Hospital): void {
    let isValChanged: boolean = this._hospital !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SearchRequest._HOSPITAL, this._hospital);

    this.updateObservable("hospital", this._hospital, val);

    this._hospital = val;

    this.fire("hospital", this);
  }
  public get(field: number): any {
    switch (field) {
      case SearchRequest._NOTES: {
        return this._notes;
      }

      case SearchRequest._REQUESTDATE: {
        return this._requestDate;
      }

      case SearchRequest._CREATEDBY: {
        return this._createdBy;
      }

      case SearchRequest._STATUS: {
        return this._status.index;
      }

      case SearchRequest._FIRSTNAME: {
        return this._firstName;
      }

      case SearchRequest._MIDDLENAME: {
        return this._middleName;
      }

      case SearchRequest._LASTNAME: {
        return this._lastName;
      }

      case SearchRequest._MOBILE: {
        return this._mobile;
      }

      case SearchRequest._DATEOFBIRTH: {
        return this._dateOfBirth;
      }

      case SearchRequest._RESPONSE: {
        return this._response;
      }

      case SearchRequest._FAILEDMESSAGE: {
        return this._failedMessage;
      }

      case SearchRequest._SSN: {
        return this._sSN;
      }

      case SearchRequest._ISADVANCEDSEARCH: {
        return this._isAdvancedSearch;
      }

      case SearchRequest._ISBILLED: {
        return this._isBilled;
      }

      case SearchRequest._SEARCHID: {
        return this._searchId;
      }

      case SearchRequest._TAHOEID: {
        return this._tahoeId;
      }

      case SearchRequest._ADDRESSLINE1: {
        return this._addressLine1;
      }

      case SearchRequest._ADDRESSLINE2: {
        return this._addressLine2;
      }

      case SearchRequest._CITY: {
        return this._city;
      }

      case SearchRequest._STATE: {
        return this._state;
      }

      case SearchRequest._ZIP: {
        return this._zip;
      }

      case SearchRequest._INVOICE: {
        return this._invoice;
      }

      case SearchRequest._NOTIFICATION: {
        return this._notification;
      }

      case SearchRequest._HOSPITAL: {
        return this._hospital;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): SearchRequest {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: SearchRequest = dbObj as SearchRequest;

    obj.id = this.id;

    obj.setNotes(this._notes);

    obj.setRequestDate(this._requestDate);

    obj.setCreatedBy(this._createdBy);

    obj.setStatus(this._status);

    obj.setFirstName(this._firstName);

    obj.setMiddleName(this._middleName);

    obj.setLastName(this._lastName);

    obj.setMobile(this._mobile);

    obj.setDateOfBirth(this._dateOfBirth);

    obj.setResponse(this._response);

    obj.setFailedMessage(this._failedMessage);

    obj.setSSN(this._sSN);

    obj.setIsAdvancedSearch(this._isAdvancedSearch);

    obj.setIsBilled(this._isBilled);

    obj.setSearchId(this._searchId);

    obj.setTahoeId(this._tahoeId);

    obj.setAddressLine1(this._addressLine1);

    obj.setAddressLine2(this._addressLine2);

    obj.setCity(this._city);

    obj.setState(this._state);

    obj.setZip(this._zip);

    obj.setInvoice(this._invoice);

    obj.setNotification(this._notification);

    obj.setHospital(this._hospital);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case SearchRequest._NOTES: {
        this.setNotes(value as string);
        break;
      }

      case SearchRequest._REQUESTDATE: {
        this.setRequestDate(value as DateTime);
        break;
      }

      case SearchRequest._CREATEDBY: {
        this.setCreatedBy(value as NOKUser);
        break;
      }

      case SearchRequest._STATUS: {
        this.setStatus(RequestStatus.values[value as number]);
        break;
      }

      case SearchRequest._FIRSTNAME: {
        this.setFirstName(value as string);
        break;
      }

      case SearchRequest._MIDDLENAME: {
        this.setMiddleName(value as string);
        break;
      }

      case SearchRequest._LASTNAME: {
        this.setLastName(value as string);
        break;
      }

      case SearchRequest._MOBILE: {
        this.setMobile(value as string);
        break;
      }

      case SearchRequest._DATEOFBIRTH: {
        this.setDateOfBirth(value as string);
        break;
      }

      case SearchRequest._RESPONSE: {
        this.setResponse((value as Array<any>).cast<Person>().toList());
        break;
      }

      case SearchRequest._FAILEDMESSAGE: {
        this.setFailedMessage(value as string);
        break;
      }

      case SearchRequest._SSN: {
        this.setSSN(value as string);
        break;
      }

      case SearchRequest._ISADVANCEDSEARCH: {
        this.setIsAdvancedSearch(value as boolean);
        break;
      }

      case SearchRequest._ISBILLED: {
        this.setIsBilled(value as boolean);
        break;
      }

      case SearchRequest._SEARCHID: {
        this.setSearchId(value as string);
        break;
      }

      case SearchRequest._TAHOEID: {
        this.setTahoeId(value as string);
        break;
      }

      case SearchRequest._ADDRESSLINE1: {
        this.setAddressLine1(value as string);
        break;
      }

      case SearchRequest._ADDRESSLINE2: {
        this.setAddressLine2(value as string);
        break;
      }

      case SearchRequest._CITY: {
        this.setCity(value as string);
        break;
      }

      case SearchRequest._STATE: {
        this.setState(value as string);
        break;
      }

      case SearchRequest._ZIP: {
        this.setZip(value as string);
        break;
      }

      case SearchRequest._INVOICE: {
        this.setInvoice(value as Invoice);
        break;
      }

      case SearchRequest._NOTIFICATION: {
        this.setNotification(value as Notification);
        break;
      }

      case SearchRequest._HOSPITAL: {
        this.setHospital(value as Hospital);
        break;
      }
    }
  }
}
